import React from 'react'

import store from '../state/store.js'

class ThemeProvider extends React.Component {
  componentDidMount (props) {
    setTimeout(() => {
      store.hydrate({
        background: this.props.color,
        page: this.props.page
      })()
    }, 300)
  }
  render () {
    return (
      <div />
    )
  }
}

export default ThemeProvider
